export default __webpack_public_path__ + "static/media/himachalpackage.882f40b5.jpg";